export default {"src":"/_next/static/media/engineering.e88f2f9a.svg","height":64,"width":64};